"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editSystemCourse = exports.getSystemCourses = exports.createSystemCourse = exports.publishSystemCourse = void 0;
var defaultResponse = {
    id: 12,
    error: '',
    message: 'Operation successfully completed',
    validationErrors: [{ errorKey: '', inputField: '' }],
    success: true,
};
// eslint-disable-next-line import/prefer-default-export
var publishSystemCourse = function () { return defaultResponse; };
exports.publishSystemCourse = publishSystemCourse;
var createSystemCourse = function () { return defaultResponse; };
exports.createSystemCourse = createSystemCourse;
var getSystemCourses = function () { return defaultResponse; };
exports.getSystemCourses = getSystemCourses;
var editSystemCourse = function () { return defaultResponse; };
exports.editSystemCourse = editSystemCourse;
